import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { loginInterface } from 'app/Model/login.Interface';
import { LoginService } from 'app/services/login.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { State } from 'app/store/reducers';
import { StoreService } from 'app/store/store.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, EMPTY, Observable, Subject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import * as menuActions from '../../../store/actions/Administracion/menus.actions';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class LoginEstudianteFacadeService {


  //Selectores
  public Menus$ = this._store.state.pipe(map((state) => state.Menus?.menus));

  //Respuesta Acción
  private response$ = new Subject<loginInterface[]>();
  public responseAction$: Observable<loginInterface[]> = this.response$.asObservable();

  private loading$ = new BehaviorSubject<any>({ loading: false, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  public responseLoading$: Observable<any> = this.loading$.asObservable();
  

  private error$ = new BehaviorSubject<any>({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.error$.asObservable();

  constructor(private _loginService: LoginService, private _toast: ToastrServiceLocal,
    private _mensajeHttp: MensajesHttpService, private _router: Router, private _store: StoreService<State>) { }


    loginEstudiante(params: any) {
      this.loading$.next({ loading: true, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
      this.error$.next({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
      const request$ = this._loginService.logueoLc('login/loginStudent', params).pipe(
        tap((result: loginInterface | any) => {
          console.log(result);
          // this._store.dispatch(new menuActions.GetMenus(result?.menus));
          result?.user?.data?.Table0.forEach(item => {
            if (item.hijos) {item.hijos = JSON.parse(item.hijos) }});
          localStorage.setItem("nombre", result?.user?.data?.Table1[0]?.nombre || '');
          const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(result?.user.data.Table0), result?.token).toString();  // Encriptar usando un token o clave
          localStorage.setItem("MFX_01", encryptedData);
          // sessionStorage.setItem(environment.tokenLocal, result?.token);
          localStorage.setItem(environment.tokenLocal, result?.token);
          this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
          this._toast.mensajeSuccess('Te damos la bienvenida al Servicio del Estudiante UNAH', '');
          
          if (result?.user?.data?.Table1[0]?.logueo === true){
            this._router.navigateByUrl('/CambioCredencial');
          }else {
          this._router.navigateByUrl('/dashboard');
          }

        }),
        catchError((error: HttpErrorResponse) => {
          this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrio un error al loguearse', '');
          this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
          this.error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrio un error al loguearse'), errors: [] });
         
          return EMPTY;
        })
      );
      return request$.subscribe();
    }
  }
